import { useSyncExternalStore } from "react";

import { getSnapshot, snackbar, subscribe } from "./snackbarStore";
import { SnackbarItem } from "./types";

/** Stable across renders, so it is safe in dependency arrays. */
export const useSnackbar = () => snackbar;

/** Only SnackbarStack needs this. */
export const useSnackbarItems = (): SnackbarItem[] =>
  useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
